import { IconButton, TooltipHost, useTheme } from '@fluentui/react';
import React from 'react';

interface ICopyButtonProps {
  value: string;
  text: string;
  copiedText: string;
  onCopied?: () => void;
}

export const CopyButton: React.FC<ICopyButtonProps> = ({ value, text, copiedText, onCopied }) => {
  const theme = useTheme();
  const [title, setTitle] = React.useState(text);

  const copyClick = () => {
    navigator.clipboard.writeText(value);
    setTitle(copiedText);
    if (onCopied) {
      onCopied();
    }
  };
  return (
    <TooltipHost content={title} calloutProps={{ gapSpace: 0 }}>
      <IconButton
        onClick={copyClick}
        iconProps={{ iconName: 'Copy' }}
        styles={{ root: { color: theme.palette.neutralPrimary } }}
      />
    </TooltipHost>
  );
};
